// @ts-nocheck

import { InfoCircleOutlined } from '@ant-design/icons';
import React from 'react';
import moment from 'moment';


import { Popover } from '../../../components/ui';
import { formatDateTimeToString } from '../../../lib/helpers';
import { driverQualificationEnum } from '../../../lib/enum';






export const DriverLicenseExpired = ({ driver }) => {
  const endDate = driver?.qualificationDocuments?.find(
    (el) =>
    el.qualification === driverQualificationEnum.driverLicense
  )?.documentEndDate;
  if (!endDate || moment(endDate).isSameOrAfter(moment().utc())) {
    return null;
  }

  return (
    <Popover
      overlayStyle={{ zIndex: 9999 }}
      width={200}
      content={`Водительское удостоверение истекло ${formatDateTimeToString(
        endDate,
        'DD.MM.YYYY'
      )}`}>

      <InfoCircleOutlined
        style={{
          cursor: 'help',
          color: 'red',
          marginLeft: '8px'
        }} />

    </Popover>);

};

export default DriverLicenseExpired;
